// extracted by mini-css-extract-plugin
export var container = "_ds-0";
export var outlet = "_ds-1";
export var outletEnter = "_ds-2";
export var outletEnterActive = "_ds-3";
export var outletExit = "_ds-4";
export var outletExitActive = "_ds-5";